import { Palette } from '@mui/material/styles/createPalette';

export enum AssistChipColor {
  gray = 'gray',
  green = 'green',
  orange = 'orange',
  red = 'red',
  blue = 'blue',
  purple = 'purple',
}

export type AssistChipColorUnion = keyof typeof AssistChipColor;

export type ColorScheme = {
  [key in keyof typeof AssistChipColor]: {
    color: (palette: Palette) => string;
    bgActiveColor: (palette: Palette) => string;
    bgColor: (palette: Palette) => string;
  };
};

export type MenuItemColorScheme = {
  [key in keyof typeof AssistChipColor]: {
    bgColor: (palette: Palette) => string;
  };
};
